import { Box, InputGroup, InputLeftElement, Input } from '@chakra-ui/react'
import { ChangeEvent, FC } from 'react'
import { BsSearch } from 'react-icons/bs'

import useFilters from '@hook/shared/use-filters'

const UsersSearcher: FC = () => {
  const { loading, usersQuery, setUsersQuery } = useFilters()

  const handleInputChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { value } = e.target

    setUsersQuery(value)
  }

  return (
    <Box w="32vw" pl={2}>
      <InputGroup size="sm" borderColor="gray.200">
        <InputLeftElement pointerEvents="none">
          <BsSearch color="var(--chakra-colors-gray-400)" />
        </InputLeftElement>
        <Input
          placeholder="Buscar..."
          borderRadius="8px"
          pl={8}
          value={usersQuery}
          onChange={handleInputChange}
          isDisabled={loading}
          _hover={{
            borderColor: 'yellow.400'
          }}
          _placeholder={{
            color: 'gray.400'
          }}
        />
      </InputGroup>
    </Box>
  )
}

export default UsersSearcher
